import SlotsHistoryFilter from './SlotsHistoryFilter';
export default SlotsHistoryFilter;